<template>
  <!-- TODO refactor -->
  <div>
    <div class="font-weight-bold d-flex">
      <span>Users</span>
      <common-badge class="ml-3">
        {{ users.length }}
      </common-badge>
    </div>
    <div class="d-flex align-center" :class="{ 'mb-5': !users.length }">
      <div class="pointer ml-auto d-flex align-center add-user__wrapper">
        <v-menu
          content-class="customers-combobox pb-1"
          transition="slide-x-transition"
          bottom
          right
          max-height="500"
        >
          <template>
            <div class="px-4 full-width" @click.stop>
              <v-text-field
                class="customers-search rounded-0 mt-4"
                v-model="searchCustomers"
                full-width
                solo
                flat
                dense
                hide-details
                tile
                prepend-inner-icon="mdi-close"
                height="30"
                @input="searchCustomer"
              >
                <template #prepend-inner>
                  <v-img src="/images/search-icon.png" width="13" height="13" />
                </template>
              </v-text-field>
              <div class="body-2 green3 pointer pt-3" @click="selectAllClickHandler">
                {{ allUsersAreSelected() ? 'Unselect' : 'Select' }} all
              </div>
            </div>
          </template>
          <template #activator="{ on, attrs }">
            <div class="d-flex pointer" v-bind="attrs" v-on="on">
              <v-img src="images/add-contact-icon.svg" height="20" max-width="20" />
              <span class="f14 green2 ml-2">Add users manually</span>
            </div>
          </template>

          <v-list dense>
            <v-list-item
              v-for="(customer, i) in customerItems"
              :key="i"
              @click.stop="customerClickHandler(customer)"
              class="px-2"
            >
              <v-list-item-icon class="mr-2 my-1" style="height: 28px">
                <v-img
                  v-if="customer.check"
                  class="mr-3"
                  src="images/selected-icon.svg"
                  width="28"
                  min-width="28"
                  height="28"
                />
                <v-img
                  v-else
                  class="mr-3"
                  src="images/empty-customer-icon.svg"
                  width="28"
                  min-width="28"
                  height="28"
                />
              </v-list-item-icon>
              <v-list-item-title class="option__title f14">
                {{ customer.name }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <v-menu
        content-class="customers-combobox pb-0"
        transition="slide-x-transition"
        bottom
        right
        :close-on-content-click="isCloseDuplicateMenuByClick"
      >
        <template #activator="{ on, attrs }">
          <div
            v-bind="attrs"
            v-on="on"
            class="ml-7 pointer d-flex align-center"
            :style="users.length ? 'display: none !important;' : ''"
          >
            <v-img src="images/new-group-icon.png" height="17" max-width="17" />
            <span class="f14 green2 ml-2 text-no-wrap">Duplicate budget entity users list</span>
          </div>
        </template>

        <template>
          <v-list class="approvement-list py-4">
            <v-list-item-group v-model="currentImportBtn">
              <v-list-item
                v-for="(entity, i) in budgetEntities.filter((be) => be.accounts.length)"
                :key="i"
                class="px-2 py-2 duplicate-item"
                :class="{
                  'pb-0': i === budgetEntities.length - 1,
                  'pt-0': i === 0,
                  active: i === currentImportBtn,
                  'approvement-list__item': currentImportBtn !== undefined,
                }"
                style="min-height: 1px"
              >
                <v-list-item-title class="option__title f14 black1">
                  <div
                    class="d-flex justify-space-between align-center"
                    v-if="currentImportBtn === i"
                  >
                    <span class="lato-bold">Import {{ entity.accounts.length }} sub accounts?</span>
                    <v-btn
                      @click.stop="currentImportBtn = undefined"
                      class="ml-auto mr-2"
                      width="18"
                      height="18"
                      icon
                    >
                      <svg
                        width="14"
                        height="14"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 14 14"
                      >
                        <defs />
                        <g fill="none" fill-rule="evenodd" stroke="#919191" stroke-width="1.636">
                          <path d="M.001 14L14 0M14 14L0 0" />
                        </g>
                      </svg>
                    </v-btn>
                    <v-btn @click="duplicateUsers(entity)" icon width="18" height="18">
                      <v-img width="18" height="18" src="/images/check-circle-icon.svg" />
                    </v-btn>
                  </div>
                  <div v-else class="d-flex justify-space-between align-center f14">
                    <span class="black1 mr-4"
                    >{{ entity.name }} ({{ entity.accounts.length }})</span
                    >
                    <span class="green2 pointer">Import</span>
                  </div>
                </v-list-item-title>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </template>
      </v-menu>

      <the-table-download-invoice v-if="isEdit" :downloadMethod="downloadCSV" />
    </div>
    <div v-if="users.length" class="mt-3 mb-2">
      <common-input
        v-model="searchUsers"
        prepend-inner-icon="mdi-magnify"
        placeholder="Search users..."
        clearable
        height="40"
        style="max-width: 220px"
      />
    </div>
    <div class="mt-2 pt-2" :class="{ 'my-7': !isEdit }">
      <v-alert
        v-if="isSettingsShow"
        class="d-flex align-center pa-3 customers-alert"
        dense
        color="#DFF3F2"
      >
        <div class="d-flex align-center f14">
          <common-select
            v-model="limit"
            :items="spendLimitOptions"
            placeholder="Select action"
            height="35"
            style="width: 100%; max-width: 220px"
          />
          <template v-if="limit === 1">
            <div class="d-flex align-center">
              XXXX
              <common-input
                v-model="commonSpendLimit"
                type="number"
                prefix="$"
                style="max-width: 75px"
                class="ml-2"
                :height="35"
              />

              <span class="ml-4 mr-2">Set period:</span>
              <common-select
                v-model="commonPeriod"
                :items="period"
                placeholder="Period"
                style="width: 120px"
                class="mr-2"
                :height="35"
              />

              <common-tooltip top :max-width="250" :z-index="8" :activator-size="20">
                <div>
                  <p><span>Spend limit is based on calendar</span></p>
                  <dl class="d-flex align-center">
                    <dt class="f14 lato-bold font-weight-bold miw90 mr-1">Monthly:</dt>
                    <dd class="f14">01 - 31</dd>
                  </dl>
                  <dl class="d-flex align-center">
                    <dt class="f14 lato-bold font-weight-bold miw90 mr-1">Yearly:</dt>
                    <dd class="f14">Jan 01 - Dec 31</dd>
                  </dl>
                </div>
              </common-tooltip>
            </div>
          </template>

          <div v-if="[1, 0].includes(limit)" class="d-flex flex-row g10 ml-auto">
            <common-button outlined style="background-color: #fff" @click="cancelBulkEdit">
              Cancel
            </common-button>
            <common-button @click="setAllLimit()" :disabled="limit === null" style="width: 60px">
              Set
            </common-button>
          </div>

          <template v-if="[2, 3].includes(limit)">
            <common-input
              v-model.number="bulkLimitEdit"
              type="number"
              prefix="$"
              class="ml-2"
              min="1"
              :height="35"
              style="max-width: 75px"
              oninput="this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null"
            />

            <div class="d-flex flex-row g10 ml-auto">
              <common-button outlined style="background-color: #fff" @click="cancelBulkEdit">
                Cancel
              </common-button>
              <common-button @click="bulkUpdate">Set</common-button>
            </div>
          </template>
        </div>
        <span class="red1" v-if="editableCustomerErrors.find((e) => e.panel)">
          {{ editableCustomerErrors.find((e) => e.panel).message }}
        </span>
        <div class="red1 mt-1" v-if="recognitionError">
          {{ recognitionError }}
        </div>
      </v-alert>
      <v-data-table
        v-show="users.length"
        v-model="tableSelectedItems"
        class="customers-table mb-4"
        :class="{ 'customers-table__first-child': !!users.length }"
        :headers="headers"
        :items="users"
        :search="searchUsers"
        :show-select="!!users.length"
        :items-per-page="users.length"
        hide-default-footer
      >
        <template #item.name="{ item }">
          <div class="f14 lato-bold d-flex">
            {{ item.name }}
          </div>
        </template>
        <template #item.limit="{ item }">
          <div class="pos-r">
            <v-text-field
              v-if="editableCustomer.id === item.id"
              v-model.number="editableCustomer.limit"
              class="rounded-0 input-icon"
              type="number"
              min="0"
              step="0.01"
              hide-details
              color="black"
              solo
              flat
              dense
              tile
              prefix="$"
              height="30"
              full-width
              @keydown="blockThousandsSeparatorKeydown"
              @paste="blockThousandsSeparatorPaste"
            />
            <span class="f14 black1" v-else-if="item.limit">
              {{
                item.limit
                  | priceFilter({
                  style: 'currency',
                  currency: 'USD',
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              }}
            </span>
            <span
              v-if="
                (editableCustomerErrors.find((e) => e.id === item.id) &&
                  editableCustomerErrors.find((e) => e.id === item.id).type === 'limit') ||
                (editableCustomerErrors.find((e) => e.id === item.id) &&
                  !editableCustomerErrors.find((e) => e.id === item.id).type)
              "
              class="red1 customers-errors"
            >
              {{ editableCustomerErrors.find((e) => e.id === item.id).message }}
            </span>
          </div>
        </template>
        <template #item.period="{ item }">
          <div class="pos-r">
            <v-select
              v-if="editableCustomer.id === item.id"
              v-model="editableCustomer.period"
              class="rounded-0 f14 customers-select__period"
              :items="period"
              hide-details
              full-width
              label="Period"
              dense
              outlined
              solo
              flat
              tile
              height="30"
            />
            <span v-else-if="item.period" class="f14 black1 d-flex flex-row g10 align-center">
              {{ getCustomerPeriod(item) }}

              <common-tooltip
                v-if="item.period_changed_at"
                :z-index="8"
                :activator-size="20"
                activator-color="#62646A"
              >
                <div class="d-flex flex-column align-center">
                  Spend limit updated on:
                  <b>{{ getPeriodTooltip(item) }}</b>
                </div>
              </common-tooltip>
            </span>
            <span
              v-if="
                editableCustomerErrors.find((e) => e.id === item.id) &&
                editableCustomerErrors.find((e) => e.id === item.id).type === 'period'
              "
              class="red1 customers-errors"
            >
              {{ editableCustomerErrors.find((e) => e.id === item.id).message }}
            </span>
          </div>
        </template>
        <template v-if="isRecognitionBudgetType" #item.balance="{ item }">
          <v-text-field
            v-if="editableCustomer.id === item.id"
            v-model.number="editableCustomer.balance"
            class="rounded-0 input-icon"
            type="number"
            min="0"
            hide-details
            color="black"
            solo
            flat
            dense
            tile
            prefix="$"
            height="30"
            full-width
          />
          <span class="f14 black1" v-if="editableCustomer.id !== item.id">
            <span>
              {{
                (item.balance || 0)
                  | priceFilter({
                  style: 'currency',
                  currency: 'USD',
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              }}
            </span>
          </span>
        </template>
        <template v-else #item.balance="{ item }">
          <span class="f14 black1" v-if="editableCustomer.id !== item.id">
            <span v-if="item.limit && item.period">
              {{
                (item.balance || 0)
                  | priceFilter({
                  style: 'currency',
                  currency: 'USD',
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              }}
            </span>
          </span>
        </template>
        <template v-if="isRecognitionBudgetType && recognitionError" #item.error="{ item }">
          <span v-if="editableCustomer.id === item.id && recognitionError" class="red1">
            {{ recognitionError }}
          </span>
        </template>
        <template #item.details="{ item }">
          <div class="d-flex flex-column">
            <div class="f14 font-weight-bold d-flex">
              <span class="">{{ item.fullName.firstName }}</span
              ><span class="ml-1">{{ item.fullName.lastName }}</span>
            </div>
            <span class="">{{ item.emailAddress }}</span>
          </div>
        </template>
        <template #item.control="{ item }">
          <div class="d-flex align-center justify-end" v-if="editableCustomer.id !== item.id">
            <v-img
              v-if="isEditUserAvaiable"
              class="mr-5"
              @click="editUser(item)"
              src="images/action_pen.png"
              height="12"
              max-width="10"
            />
            <v-img
              @click="deleteUser(item)"
              src="images/delete-icon.svg"
              height="17"
              max-width="14"
            />
          </div>
          <div v-else class="d-flex align-center justify-end">
            <span class="f14 green2 pointer customers-cancel" @click="saveEditingCustomer(item)">Set</span>
            <v-divider class="mx-2" vertical />
            <span class="f14 green2 pointer customers-cancel" @click="cancelEditingCustomer(item)">
              {{ isRecognitionBudgetType ? 'Cancel' : (!item.limit ? 'Cancel' : 'Remove limit') }}
            </span>
          </div>
        </template>
      </v-data-table>
    </div>

    <v-dialog v-model="showSpendLimitModal" persistent content-class="elevation-0" width="500">
      <div class="spend-limit-update-modal__wrapper">
        <div class="spend-limit-update-modal__content">
          <div class="spend-limit-update-modal__title">Spend limit updated</div>

          <div class="spend-limit-update-modal__text">
            Pay attention that when spend limit is updated - the user’s <b>balance</b> is reset
            according to the new spend <b>limit</b>. <br /><br />
            Start date of the new spend limit is shown next to the selected period in tooltip.
          </div>

          <cg-checkbox v-model="hideSpendLimitModal">Don't show this modal again</cg-checkbox>

          <div class="spend-limit-update-modal__actions">
            <cg-button @click="showSpendLimitModal = false">Close</cg-button>
          </div>
        </div>

        <v-icon color="white" class="pointer" @click="showSpendLimitModal = false">
          mdi-close
        </v-icon>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import Api from '@/axios/api';
import { cloneDeep, toNumber, isEmpty } from 'lodash';
import { createNamespacedHelpers } from 'vuex';

import { customersHeaders } from '@/assets/headers';
import { isEdit, selectedEntity, budgetEntities } from '../mixins';

import { CgButton, CgCheckbox } from '@corporategiftcom/design-system';
import TheTableDownloadInvoice from '../TheTableDownloadInvoice.vue';
import { blockThousandsSeparatorKeydown, blockThousandsSeparatorPaste } from '@/utils/blockAmountSeparatorKeydown';

const { mapGetters, mapMutations } = createNamespacedHelpers('budgetEntities');

export default {
  name: 'Customers',
  mixins: [isEdit, selectedEntity, budgetEntities],
  components: {
    CgButton,
    CgCheckbox,
    TheTableDownloadInvoice,
  },
  props: {
    // TODO remove showPanel
    showPanel: Boolean,
    accounts: {
      type: Array,
      required: true,
    },
    budgetEntityId: {
      type: Number,
      required: false,
      default: null,
    },
    availableBalance: {
      type: Number,
      required: false,
      default: 0,
    },
    initialBalance: {
      type: Number,
      required: false,
      default: 0,
    },
    isRecognitionBudgetType: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    hideSpendLimitModal: false,
    showSpendLimitModal: false,
    currentImportBtn: undefined,
    isCloseDuplicateMenuByClick: false,
    selectedCustomers: [], // change this value and Watch will change store selectedEntity
    limit: null,
    commonSpendLimit: null,
    commonPeriod: '',
    searchUsers: '',
    searchCustomers: '',
    customerItems: [],
    bulkLimitEdit: null,
    period: [
      {
        text: 'Monthly',
        value: 'monthly',
      },
      {
        text: 'Annually',
        value: 'annually',
      },
      {
        text: 'No time limit',
        value: 'no_time_limit',
      },
    ],
    tableSelectedItems: [],
    editableCustomer: {},
    editableCustomerErrors: [],
    recognitionError: '',
  }),
  watch: {
    selectedCustomers(val) {
      const customers = val?.map((item) => {
        return item;
      });
      this.$emit('setAccounts', customers);
    },
    accounts: {
      handler: function (val) {
        if (!this.customerItems.length) {
          this.customerItems = cloneDeep(this.accounts);
        }
      },
      immediate: true,
      deep: true,
    },
    isEdit() {
      this.editableCustomer = {};
      this.tableSelectedItems = [];
      this.searchUsers = '';
    },
    limit(val) {
      if (!val) {
        this.commonPeriod = '';
        this.commonSpendLimit = null;
        this.editableCustomerErrors = this.editableCustomerErrors.filter((e) => !e.panel);
      }
    },
    errors(val) {
      for (const key in val) {
        const customerData = this.getCustomerByIndex(key);
        const customer = customerData.customer;
        const type = customerData.type;

        if (!isEmpty(customer)) {
          const errors = [...this.editableCustomerErrors];
          const customerError = errors.find((e) => e.id === customer.id);

          if (customerError) {
            customerError.message = val[key][0];
            this.editableCustomerErrors = errors;
          } else {
            this.editableCustomerErrors.push({
              id: customer.id,
              message: val[key][0],
              type,
            });
          }
        }
      }
    },
    hideSpendLimitModal: function (val) {
      if (val) {
        sessionStorage.setItem('hideSpendLimitModal', true);
      } else {
        sessionStorage.removeItem('hideSpendLimitModal');
      }
    },
  },
  computed: {
    ...mapGetters(['errors']),
    users() {
      return this.selectedEntity.accounts;
    },
    isSettingsShow() {
      return this.tableSelectedItems.length;
    },
    allSelectedUsersHasSpendLimit() {
      const { users, tableSelectedItems } = this;

      if (!tableSelectedItems.length) {
        return false;
      }
      const ids = tableSelectedItems.map((item) => item.id);

      return users.filter((user) => ids.includes(user.id)).every((user) => user.limit);
    },
    spendLimitOptions() {
      const { allSelectedUsersHasSpendLimit, isRecognitionBudgetType } = this;

      if (isRecognitionBudgetType) {
        return [
          {
            text: 'Increase balance by',
            value: 2,
          },
          {
            text: 'Decrease balance by',
            value: 3,
          },
        ];
      }

      return [
        {
          text: 'Remove spend limit',
          value: 0,
        },
        {
          text: 'Set spend limit',
          value: 1,
        },
        {
          text: 'Increase limit by',
          value: 2,
          disabled: !allSelectedUsersHasSpendLimit,
        },
        {
          text: 'Decrease limit by',
          value: 3,
          disabled: !allSelectedUsersHasSpendLimit,
        },
      ];
    },
    headers() {
      return this.getCustomersHeaders(this.isRecognitionBudgetType);
    },
    isEditUserAvaiable() {
      return !(this.isRecognitionBudgetType && !this.isEdit);
    },
  },
  created() {
    this.limit = null;
    this.tableSelectedItems = [];
    if (this.showPanel) {
      this.selectedCustomers = cloneDeep(this.selectedEntity.accounts);

      if (!this.customerItems.length) {
        this.customerItems = cloneDeep(this.accounts);
      }

      this.updateCustomerItems();
    } else {
      this.selectedCustomers = [];
      this.customerItems = [];
    }
  },
  methods: {
    ...mapMutations(['setErrors']),
    blockThousandsSeparatorKeydown,
    blockThousandsSeparatorPaste,
    getCustomerByIndex(key) {
      const keySplit = key.split('.');
      if (keySplit[1]) {
        // if second element exist
        const index = toNumber(keySplit[1]);
        const type = toNumber(keySplit[keySplit.length - 1]);

        return {
          customer: this.users[index],
          type,
        };
      }

      return {};
    },
    getCustomerPeriod({ period }) {
      const { period: periodsData } = this;
      const userPeriod = periodsData.find(({ value }) => value === period);

      return userPeriod?.text ?? null;
    },
    getPeriodTooltip({ period_changed_at }) {
      const dateFormatter = new Intl.DateTimeFormat('en', { year: 'numeric', month: 'long' });
      const currentDate = new Date(period_changed_at);

      return dateFormatter.format(currentDate);
    },
    informUserAboutSpendLimitUpdate() {
      const hideSpendLimitModal = sessionStorage.getItem('hideSpendLimitModal');
      if (!hideSpendLimitModal) {
        this.showSpendLimitModal = true;
      }
    },
    addUser(user) {
      this.accounts.find((item) => item === user).selected = !this.accounts.find(
        (item) => item === user,
      ).selected;
    },
    deleteUser(item) {
      if (!this.tableSelectedItems.length) {
        const deletedItem = this.customerItems.find((e) => e.id === item.id);
        delete deletedItem.check;

        this.selectedCustomers = this.selectedCustomers.filter(
          (customer) => customer.id !== item.id,
        );
        this.editableCustomerErrors = this.editableCustomerErrors.filter((e) => e.id !== item.id);
      }
      if (this.isRecognitionBudgetType) {
        this.releaseLimitToFreeBalance(item);
        this.recognitionError = '';
      }
    },
    editUser(item) {
      if (!this.tableSelectedItems.length) {
        this.recognitionError = '';
        if (this.editableCustomer.id) {
          if (this.editableCustomer.limit === null || this.editableCustomer.period === null) {
            this.editableCustomer.limit = null;
            this.editableCustomer.period = null;
          }
          this.editableCustomerErrors = [];
        }
        const customer = structuredClone(item);
        this.editableCustomer = {
          ...customer,
          limit: this.toAmount(customer.limit),
          balance: this.toAmount(customer.balance),
        };
      }
    },
    setAllLimit() {
      if (this.limit) {
        let error = '';

        if (!toNumber(this.commonSpendLimit)) {
          error = 'Limit is required';
        }

        if (!this.commonPeriod) {
          error = 'Period is required';
        }

        if (!toNumber(this.commonSpendLimit) && !this.commonPeriod) {
          error = 'Limit and period are required';
        }

        if (!error) {
          this.setCommonSpendLimit();
        } else {
          const errors = [...this.editableCustomerErrors];
          const errIndex = errors.findIndex((e) => e.panel);

          if (~errIndex) {
            errors[errIndex] = {
              panel: true,
              message: error,
            };
            this.editableCustomerErrors = errors;
          } else {
            this.editableCustomerErrors.push({
              panel: true,
              message: error,
            });
          }
        }
      } else {
        this.setCommonSpendLimit();
      }
    },
    setCommonSpendLimit() {
      this.selectedEntity.accounts.forEach((account) => {
        this.tableSelectedItems.forEach((item) => {
          if (item.id === account.id) {
            account.limit = this.roundAmount(this.commonSpendLimit);
            account.period = this.commonPeriod;
            account.balance = this.roundAmount(this.commonSpendLimit);
            account.period_changed_at = new Date();
          }
        });
      });

      this.editableCustomerErrors = this.editableCustomerErrors.filter((e) => !e.panel);
      this.clearDataForSetMultipleLimits();
    },
    clearDataForSetMultipleLimits() {
      this.limit = null;
      this.commonSpendLimit = null;
      this.commonPeriod = null;
      this.tableSelectedItems = [];
    },
    searchCustomer() {
      this.searchCustomers.length
        ? (this.customerItems = this.accounts.filter((selected) =>
          selected.name.toLowerCase().includes(this.searchCustomers.toLowerCase()),
        ))
        : (this.customerItems = this.accounts);
    },
    customerClickHandler(customer) {
      if (customer.check) {
        customer.check = false;
        this.selectedCustomers = this.selectedCustomers.filter((c) => customer.id !== c.id);
      } else {
        customer.check = true;
        this.selectedCustomers.push(customer);
      }
    },
    selectAllClickHandler() {
      const { customerItems, selectedCustomers, allUsersAreSelected } = this;

      if (allUsersAreSelected()) {
        customerItems.forEach((customer) => (customer.check = false));
        selectedCustomers.splice(0, selectedCustomers.length);
      } else {
        customerItems.forEach((customer) => {
          customer.check = true;
          if (!selectedCustomers.some((selected) => selected.id === customer.id))
            selectedCustomers.push(customer);
        });
      }
    },
    allUsersAreSelected() {
      const {
        selectedCustomers: { length: selectedLength },
        customerItems: { length: customersLength },
      } = this;

      return selectedLength === customersLength;
    },
    duplicateUsers(be) {
      this.isCloseDuplicateMenuByClick = true;
      if (this.isRecognitionBudgetType) {
        this.selectedCustomers = be.accounts.map(acc => ({
          ...acc,
          limit: 0
        }));
      } else {
        this.selectedCustomers = be.accounts;
      }
      setTimeout(() => {
        this.isCloseDuplicateMenuByClick = false;
      });
      this.updateCustomerItems();
    },
    saveEditingCustomer(item) {
      if (this.isRecognitionBudgetType) {
        const newBalance = this.roundAmount(this.editableCustomer.balance);
        const oldBalance = this.roundAmount(item.balance);
        const available = Number(this.initialBalance || 0);

        const maxAllowed = available + oldBalance;

        if (newBalance > maxAllowed) {
          const exceeded = newBalance - maxAllowed;
          this.recognitionError = `Exceeds available budget by $${exceeded.toFixed(2)}`;
          return;
        }

        if (newBalance < 0) {
          this.recognitionError = 'Balance cannot be negative';
          return;
        }

        const change = newBalance - oldBalance;

        const newAvailableBalance = this.roundAmount(available - change);

        // Go through selectedCustomers so the change is emitted to the parent form
        // instead of mutating the table row in place (which left selectedCustomers stale).
        const accounts = structuredClone(this.selectedCustomers);
        const accIndex = accounts.findIndex((acc) => acc.id === item.id);
        if (~accIndex) {
          accounts[accIndex] = { ...accounts[accIndex], balance: newBalance };
          this.selectedCustomers = accounts;
        } else {
          item.balance = newBalance;
        }
        this.$emit('balanceUpdated', newAvailableBalance);

        this.editableCustomer = {};
        this.recognitionError = '';
        return;
      }

      const validateSpendLimit = this.validateSpendLimit(this.editableCustomer);

      if (!Object.keys(validateSpendLimit).length) {
        // if limit and period are valid
        this.setSpendLimit(item);
      } else {
        const errors = [...this.editableCustomerErrors];
        const errIndex = errors.findIndex((e) => item.id === e.id);

        if (~errIndex) {
          errors[errIndex] = validateSpendLimit;
          this.editableCustomerErrors = errors;
        } else {
          this.editableCustomerErrors.push(validateSpendLimit);
        }
      }
    },
    setSpendLimit(item) {
      const accIndex = this.selectedCustomers.findIndex((acc) => acc.id === item.id);
      const accounts = structuredClone(this.selectedCustomers);

      const newPeriod = this.editableCustomer.period;
      const currentPeriod = this.selectedCustomers[accIndex]?.period;

      const showSpendLimitInfo = currentPeriod && newPeriod && newPeriod !== currentPeriod;

      const limit = this.editableCustomer.limit === null ? null : this.roundAmount(this.editableCustomer.limit);

      accounts[accIndex] = {
        ...this.editableCustomer,
        limit,
        balance: limit,
        period_changed_at: this.editableCustomer?.period_changed_at || new Date(),
      };
      this.selectedCustomers = accounts;
      this.editableCustomer = {};

      if (showSpendLimitInfo) {
        this.informUserAboutSpendLimitUpdate();
      }
      this.editableCustomerErrors = this.editableCustomerErrors.filter((e) => e.id !== item.id);
    },
    cancelEditingCustomer(customer) {
      if (this.isRecognitionBudgetType) {
        // Cancel only discards the edit. setSpendLimit() would overwrite balance with limit.
        this.recognitionError = '';
        this.editableCustomer = {};
        this.editableCustomerErrors = this.editableCustomerErrors.filter((e) => e.id !== customer.id);
        return;
      }
      this.editableCustomer.limit = null;
      this.editableCustomer.period = null;
      this.editableCustomer.balance = null;
      this.setSpendLimit(customer);
      this.editableCustomerErrors = this.editableCustomerErrors.filter((e) => e.id !== customer.id);
    },
    updateCustomerItems() {
      this.selectedCustomers.length &&
      this.selectedCustomers.forEach((selectedAcc) => {
        this.customerItems.forEach((acc) => {
          if (selectedAcc.id === acc.id) {
            acc.check = true;
          }
        });
      });
    },
    validateSpendLimit(customer) {
      if (!toNumber(customer.limit) && !customer.period) {
        return {
          id: customer.id,
          message: 'Limit and period are required fields',
        };
      }

      if (!toNumber(customer.limit)) {
        return {
          id: customer.id,
          message: 'Limit is required',
          type: 'limit',
        };
      }

      if (!customer.period) {
        return {
          id: customer.id,
          message: 'Period is required',
          type: 'period',
        };
      }

      return {};
    },
    bulkUpdate() {
      // 2 increase
      // 3 decrease
      const { tableSelectedItems, bulkLimitEdit, limit, isRecognitionBudgetType } = this;

      if (!bulkLimitEdit) return;

      if (isRecognitionBudgetType) {
        const amountPerUser = Number(this.bulkLimitEdit || 0);
        const totalAmount = amountPerUser * this.tableSelectedItems.length;

        if (limit === 2) {
          const currentFreeBalance = Number(this.initialBalance || 0);

          if (totalAmount > currentFreeBalance) {
            this.recognitionError = `Cannot allocate $${totalAmount}, available free balance is $${currentFreeBalance}`;
            return;
          }

          this.selectedCustomers = this.selectedCustomers.map((acc) => {
            if (this.tableSelectedItems.some((t) => t.id === acc.id)) {
              return { ...acc, balance: this.roundAmount(this.roundAmount(acc.balance) + amountPerUser) };
            }
            return acc;
          });

          const remainingBalance = currentFreeBalance - totalAmount;
          this.$emit('balanceUpdated', remainingBalance);
        } else if (limit === 3) {
          const maxBudget = Number(this.availableBalance || 0);
          const currentFreeBalance = Number(this.initialBalance || 0);

          let actualTotalDeducted = 0;
          this.tableSelectedItems.forEach((item) => {
            const user = this.selectedCustomers.find((acc) => acc.id === item.id);
            if (user) {
              actualTotalDeducted += Math.min(this.roundAmount(user.balance), amountPerUser);
            }
          });

          const newFreeBalance = currentFreeBalance + actualTotalDeducted;

          if (actualTotalDeducted === 0 || newFreeBalance > maxBudget) {
            if (actualTotalDeducted === 0) {
              this.recognitionError = `Cannot subtract $${amountPerUser}, selected users have insufficient balance`;
            } else {
              this.recognitionError = `Cannot subtract, would exceed max budget of $${maxBudget}`;
            }
            return;
          }

          this.selectedCustomers = this.selectedCustomers.map((acc) => {
            if (this.tableSelectedItems.some((t) => t.id === acc.id)) {
              const balance = this.roundAmount(acc.balance);
              const actualDeduction = Math.min(balance, amountPerUser);
              return { ...acc, balance: this.roundAmount(balance - actualDeduction) };
            }
            return acc;
          });

          this.$emit('balanceUpdated', newFreeBalance);
        }

        this.cancelBulkEdit();
        this.recognitionError = '';
        return;
      }

      this.selectedEntity.accounts.forEach((account) => {
        tableSelectedItems.forEach((item) => {
          if (item.id === account.id) {
            const amount = this.roundAmount(bulkLimitEdit);
            let newLimit = this.roundAmount(account.limit);
            let newBalance = this.roundAmount(account.balance);

            if (limit === 2) {
              newLimit += amount;
              newBalance += amount;
            } else {
              newLimit -= amount;
              newBalance -= amount;
            }

            account.limit = Math.max(this.roundAmount(newLimit), 0);
            account.balance = Math.max(this.roundAmount(newBalance), 0);

            if (!account.limit) {
              account.limit = null;
              account.period = null;
              account.balance = null;
            }
          }
        });
      });

      this.cancelBulkEdit();
    },
    cancelBulkEdit() {
      if (this.isRecognitionBudgetType) {
        this.recognitionError = '';
      }
      this.bulkLimitEdit = null;
      this.clearDataForSetMultipleLimits();
    },
    downloadCSV() {
      return Api.get(`/credit/budget-entities/${this.budgetEntityId}/accounts/csv`).then(
        (response) => {
          this.$store.commit('downloadCSV', { data: response });
        },
      );
    },
    getCustomersHeaders(isRecognitionBudgetType) {
      let headers = [...customersHeaders];
      if (isRecognitionBudgetType) {
        headers = headers.filter((h) => !['limit', 'period'].includes(h.value));
        return headers.map((h) => {
          if (h.value === 'balance') {
            return { ...h, width: '80', align: 'left' };
          }
          if (h.value === 'control') {
            return { ...h, width: '100' };
          }
          return h;
        });
      }
      return headers;
    },
    // API returns amounts as decimal strings (e.g. "6.45000000"); keep null as null.
    toAmount(value) {
      if (value === null || value === undefined || value === '') {
        return null;
      }
      const num = Number(value);
      return Number.isNaN(num) ? null : num;
    },
    // Balances are money: keep 2 decimals and avoid floating point drift.
    roundAmount(value) {
      return Math.round((this.toAmount(value) || 0) * 100) / 100;
    },
    releaseLimitToFreeBalance(customer) {
      if (this.isRecognitionBudgetType) {
        const customerLimit = Number(customer.balance || 0);
        if (customerLimit > 0) {
          const currentFreeBalance = Number(this.initialBalance || 0);
          const newFreeBalance = currentFreeBalance + customerLimit;
          this.$emit('balanceUpdated', newFreeBalance);
        }
      }
    },
  },
};
</script>

<style lang="scss">
@import 'src/css/customers';
</style>

<style lang="scss" scoped>
.spend-limit-update-modal {
  &__wrapper {
    gap: 12px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: flex-start;
  }

  &__content {
    gap: 20px;
    display: flex;
    border-radius: 8px;
    background-color: #fff;
    flex-direction: column;
    align-items: flex-start;
    padding: 30px;
  }

  &__title {
    font-family: 'Lato-Bold', sans-serif;
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
    color: #000;
  }

  &__text {
    font-family: 'Lato-Regular', sans-serif;
    font-weight: 400;
    font-size: 15px;
    line-height: 22px;
    color: #000;

    & > b {
      font-family: 'Lato-Bold', sans-serif;
      font-weight: 700;
    }
  }

  &__actions {
    gap: 12px;
    display: flex;
    flex-direction: row;

    & > button,
    & > a {
      border-radius: 100px;
    }
  }
}
</style>
